import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConnectionUnavailableScreenService {
  readonly isConnectionUnavailable = signal(this.isBrowserOffline());

  constructor() {
    if (typeof window === 'undefined') {
      return;
    }

    window.addEventListener('offline', this.handleOffline);
    window.addEventListener('online', this.handleOnline);
  }

  showConnectionUnavailable(): void {
    this.isConnectionUnavailable.set(true);
  }

  hideConnectionUnavailable(): void {
    this.isConnectionUnavailable.set(false);
  }

  isConnectionUnavailableError(error: HttpErrorResponse): boolean {
    return error.status === 0 || this.isBrowserOffline();
  }

  private readonly handleOffline = (): void => {
    this.showConnectionUnavailable();
  };

  private readonly handleOnline = (): void => {
    this.hideConnectionUnavailable();
  };

  private isBrowserOffline(): boolean {
    return typeof navigator !== 'undefined' && navigator.onLine === false;
  }
}
